import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'
import cookie from '~/utils/cookie'
// import cookie from '~/utils/cookie'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/admin'
  },
  {
    // 登录页
    path: '/admin',

    component: () => import('../views/admin')
  },
  {
    // 首页，发布会议
    path: '/releaseMeeting',
    component: () => import('../views/releaseMeeting'),
    children: [
      {
        path: 'auditing',
        component: () => import('../views/releaseMeeting/auditing')
      },
      {
        path: 'releasing',
        name: 'releasing',
        component: () => import('../views/releaseMeeting/releasing')
      },
      {
        path: '',
        component: () => import('../views/releaseMeeting/auditing')
      }
    ]
  },
  {
    // 预览发布
    path: '/previewRelease',
    name: 'previewRelease',
    component: () => import('../views/previewRelease')
  },
  {
    // 管理已发布的会议
    path: '/manageMeeting',
    component: () => import('../views/manageMeeting'),
    children: [
      {
        path: 'released',
        component: () => import('../views/manageMeeting/released')
      },
      {
        path: 'disabled',
        component: () => import('../views/manageMeeting/disabled')
      },
      {
        path: '',
        component: () => import('../views/manageMeeting/released')
      }
    ]
  },
  {
    // 查看会议详情
    path: '/meetingDetails',
    name: 'meetingDetails',
    component: () => import('../views/meetingDetails')
  },
  {
    // 编辑会议
    path: '/editMeeting',
    name: 'editMeeting',
    component: () => import('../views/editMeeting')
  },
  {
    // 认领会议的审核
    path: '/auditingClaim',
    component: () => import('../views/auditingClaim'),
    children: [
      {
        path: 'claims',
        component: () => import('../views/auditingClaim/claims')
      },
      {
        path: 'approved',
        component: () => import('../views/auditingClaim/approved')
      },
      {
        path: 'rejected',
        component: () => import('../views/auditingClaim/rejected')
      },
      {
        path: '',
        component: () => import('../views/auditingClaim/claims')
      }
    ]
  },
  {
    // 管理账号，只有超级管理员可见
    path: '/manageAccount',
    component: () => import('../views/manageAccount'),
    meta: {
      requireSuperAdmin: true
    },
    children: [
      {
        path: 'enabled',
        component: () => import('../views/manageAccount/accountEnabled')
      },
      {
        path: 'disabled',
        component: () => import('../views/manageAccount/accountDisabled')
      },
      {
        path: '',
        component: () => import('../views/manageAccount/accountEnabled')
      }
    ]
  },
  {
    // 移动端小程序管理
    path: '/miniprogramManage',
    component: () => import('../views/miniprogramManage'),
    children: [
      {
        path: 'bannerImage',
        component: () => import('../views/miniprogramManage/bannerImage')
      },
      {
        path: '',
        component: () => import('../views/miniprogramManage/bannerImage')
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  if (cookie.get('token')) {
    if (to.matched.some(res => res.meta.requireSuperAdmin)) {
      let me = JSON.parse(cookie.get('me'))
      if (me.role_type === 1) {
        next()
      } else if (me.role_type === 2) {
        next('/releaseMeeting')
      }
    } else {
      next()
    }
  } else if (to.path !== '/admin') {
    next('/admin')
  }
  next()
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js